import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http } from '@skylab-angular-shared/core';
import { Command, ConsoleLogger, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface EInvoiceReceivedCreateEInvoiceParams {
    readonly ksefReferenceNumber: string;
}

export type EInvoiceReceivedCreateEInvoiceResponse = {
    documentNumber: string,
} | null;

export class EInvoiceReceivedCreateEInvoiceCommand extends Command<EInvoiceReceivedCreateEInvoiceParams, EInvoiceReceivedCreateEInvoiceResponse> { }

@CommandHandlerFor(EInvoiceReceivedCreateEInvoiceCommand)
@Injectable({ providedIn: 'root'})
export class EInvoiceReceivedCreateEInvoiceCommandHandler {
    #Url = TaggedUrl.join('eInvoices/headers/:ksefReferenceNumber/ePurchaseInvoice', [Tags.Api]);
    #logger = new ConsoleLogger(this.constructor.name);
    #http = inject(Http) as HttpService;

    public async handleAsync(cmd: EInvoiceReceivedCreateEInvoiceCommand): Promise<EInvoiceReceivedCreateEInvoiceResponse> {
		const { ksefReferenceNumber } = cmd.params!;
        const url = fillPlaceholders(this.#Url, { ksefReferenceNumber });

        try {
            const { data } = await this.#http.post(url);
            return data;
        } catch(err) {
            this.#logger.error(err);
            return null;
        }
    }
}
